export const DIRECCION_ATENCION = "Av. Vélez Sarsfield 1029, Córdoba";
